export const Status = {
  NotFound: 404,
  Unauthorized: 401,
};
